

















































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { QrCodeResourcePayload } from '@/models'

import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class QrCodeForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: QrCodeResourcePayload | null

  @Prop({ type: Number, required: true })
  readonly businessUnitId!: number

  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  isValid = false

  location = ''
  isActive = true
  isPrepaid = true

  @Watch('data', { immediate: true })
  onDataChange () {
    if (this.data === null) {
      this.location = ''
      this.isActive = true
      this.isPrepaid = true
    } else {
      this.location = this.data.locationName
      this.isActive = this.data.active
      this.isPrepaid = this.data.prepay
    }
  }

  @Watch('location')
  onLocationChange () {
    this.updateModel()
  }

  @Watch('isActive')
  onIsActiveChange () {
    this.updateModel()
  }

  @Watch('isPrepaid')
  onIsPrepaidChange () {
    this.updateModel()
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  @Emit('update:isValid')
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): QrCodeResourcePayload {
    return {
      shopId: this.businessUnitId,
      locationName: this.location,
      prepay: this.isPrepaid,
      active: this.isActive
    }
  }

  submit () {
    if (this.isValid) {
      this.$emit('submit')
    }
  }
}
